import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import styled from "styled-components";

import PlayStore from '../../assets/images/play-store.png'
import AppStore from '../../assets/images/app-store.png'

const AppLinks = () => {
	return (
		<Wrapper>
			<a
				href='https://play.google.com/store/apps/details?id=com.beriatech.bajatuseguro&hl=es_MX'
				target='_blank'>
				<img
					className='mr-3 app-link-img'
					src={PlayStore}
					alt='play'
				/>
			</a>
			<a
				href='https://apps.apple.com/us/app/bajatuseguro/id902536237?l=es'
				target='_blank'>
				<img
					className='mr-3 app-link-img'
					src={AppStore}
					alt='app'
				/>
			</a>
		</Wrapper>
	);
};

export default AppLinks;
const Wrapper = styled.div`
	height: 40px;
	display: flex;

	.app-link-img {
		width: 150px;
		max-width: 150px;
		height: 40px;
		object-fit: fit;
		border-radius: 4px;
		margin-bottom: 1rem;
	}
`;
